/* NO ZOOM ON INPUT FIELDS */ 
/*
(() => {
  const ua = navigator.userAgent || "";
  const isiOS =
    /iP(ad|hone|od)/.test(ua) || (ua.includes("Mac") && navigator.maxTouchPoints > 1);

  if (!isiOS) return;

  const meta = document.querySelector('meta[name="viewport"]');
  if (!meta) return;

  const original = meta.getAttribute("content") || "";

  function addMaxScaleOne(content) {
    const cleaned = content
      .replace(/,\s*maximum-scale\s*=\s*[^,]+/gi, "")
      .replace(/,\s*user-scalable\s*=\s*[^,]+/gi, "");
    const base = cleaned.trim() || "width=device-width, initial-scale=1";
    return base + ", maximum-scale=1";
  }

  function onInputTarget(t) {
    return t && t.closest && t.closest("input, textarea, select");
  }

  function lockZoom() {
    meta.setAttribute("content", addMaxScaleOne(original));
  }

  function unlockZoom() {
    meta.setAttribute("content", original);
  }

  // Run BEFORE focus happens
  ["pointerdown", "touchstart", "mousedown"].forEach((evt) => {
    document.addEventListener(evt, (e) => {
      if (onInputTarget(e.target)) lockZoom();
    }, true);
  });

  // Restore after leaving the field
  document.addEventListener("focusout", (e) => {
    if (onInputTarget(e.target)) setTimeout(unlockZoom, 0);
  }, true);
})();
*/

/* NO iOS ZOOM on small-font inputs — includes generic submit buttons */
(() => {
  const ua = navigator.userAgent || "";
  const isiOS =
    /iP(ad|hone|od)/.test(ua) || (ua.includes("Mac") && navigator.maxTouchPoints > 1);
  if (!isiOS) return;

  const meta = document.querySelector('meta[name="viewport"]');
  if (!meta) return;

  const original = meta.getAttribute("content") || "";

  const addMaxScaleOne = (content) => {
    const cleaned = content
      .replace(/,\s*maximum-scale\s*=\s*[^,]+/gi, "")
      .replace(/,\s*user-scalable\s*=\s*[^,]+/gi, "");
    const base = cleaned.trim() || "width=device-width, initial-scale=1";
    return base + ", maximum-scale=1";
  };

  const lockZoom = () => meta.setAttribute("content", addMaxScaleOne(original));
  const unlockZoom = () => meta.setAttribute("content", original);

  const isFormField = (t) => t && t.closest && t.closest("input, textarea, select");

  const isSubmitForFormWithFields = (t) => {
    if (!t || !t.closest) return false;

    const submit = t.closest('button[type="submit"], input[type="submit"], [type="submit"]');
    if (!submit) return false;

    const form = submit.form || submit.closest("form");
    if (!form) return false;

    // any “texty” fields in that form
    return !!form.querySelector(
      'input:not([type="hidden"]):not([type="submit"]):not([type="button"]):not([type="checkbox"]):not([type="radio"]), textarea, select'
    );
  };

  const shouldLock = (t) => isFormField(t) || isSubmitForFormWithFields(t);

  // BEFORE focus happens
  ["pointerdown", "touchstart", "mousedown"].forEach((evt) => {
    document.addEventListener(evt, (e) => {
      if (shouldLock(e.target)) lockZoom();
    }, true);
  });

  // any other focus path
  document.addEventListener("focusin", (e) => {
    if (isFormField(e.target)) lockZoom();
  }, true);

  document.addEventListener("focusout", (e) => {
    if (isFormField(e.target)) setTimeout(unlockZoom, 0);
  }, true);

  window.addEventListener("blur", unlockZoom);
})();





/* newsletter popup test  */ 
(() => {
  const modal = document.querySelector('[data-noah-subscribe-modal]');
  if (!modal) return;

  const input = modal.querySelector('#NoahSubscribeEmail');
  const closeBtns = modal.querySelectorAll('[data-noah-subscribe-close]');

  const setOpen = (open) => {
    modal.hidden = !open;
    modal.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.documentElement.classList.toggle('noah-subscribe-open', open);
    document.body.classList.toggle('noah-subscribe-open', open);

    if (open) {
      // small delay so focus works reliably on iOS
      setTimeout(() => input && input.focus(), 50);
    } else {
      // remove hash without jumping
      if (location.hash === '#noah-subscribe') {
        history.replaceState(null, '', location.pathname + location.search);
      }
    }
  };

  const open = () => setOpen(true);
  const close = () => setOpen(false);

  // Click footer link (or any link) pointing to the hash
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[href="#noah-subscribe"], a[href="/#noah-subscribe"]');
    if (!a) return;
    e.preventDefault();
    open();
  });

  // Close actions
  closeBtns.forEach((btn) => btn.addEventListener('click', close));

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !modal.hidden) close();
  });

  // Open if loaded with hash
  if (location.hash === '#noah-subscribe') open();

  // Open after submit if success/error happened (page reload)
  if (modal.dataset.openOnLoad === 'true') open();
})();
